(() => {
  const SELECTOR = 'media-gallery .product-media-container.media-type-image';
  const MIN_SCALE = 1;
  const MAX_SCALE = 4;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  function initViewport(viewport) {
    if (!viewport || viewport.dataset.localZoomReady === 'true') return;
    const content = viewport.querySelector('.product__media');
    const mediaItem = viewport.closest('.product__media-item');
    if (!content || !mediaItem) return;
    viewport.dataset.localZoomReady = 'true';

    let scale = 1, x = 0, y = 0, startScale = 1, startDistance = 0;
    let startMid = null, panStart = null, moved = false, lastTap = 0;
    const overlays = () => Array.from(mediaItem.querySelectorAll(':scope > .royal-pop-pdp-gallery__overlay'));
    const apply = () => {
      if (scale <= 1.001) {
        scale = 1; x = 0; y = 0;
        content.style.removeProperty('transform');
        overlays().forEach(el => el.style.removeProperty('transform'));
        viewport.classList.remove('is-local-zoomed','is-local-zoom-panning');
        return;
      }
      const rect = viewport.getBoundingClientRect();
      x = clamp(x, -(rect.width * scale - rect.width), 0);
      y = clamp(y, -(rect.height * scale - rect.height), 0);
      const value = `translate3d(${x}px,${y}px,0) scale(${scale})`;
      content.style.transform = value;
      overlays().forEach(el => { el.style.transform = value; });
      viewport.classList.add('is-local-zoomed');
    };
    const reset = () => { scale = 1; x = 0; y = 0; apply(); };
    const dist = (a,b) => Math.hypot(b.clientX-a.clientX,b.clientY-a.clientY);
    const mid = (a,b) => ({x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2});

    viewport.addEventListener('touchstart', e => {
      moved = false;
      if (e.touches.length === 2) {
        e.preventDefault();
        startDistance = dist(e.touches[0],e.touches[1]);
        startScale = scale;
        startMid = mid(e.touches[0],e.touches[1]);
        viewport.classList.add('is-local-zoom-panning');
      } else if (e.touches.length === 1 && scale > 1) {
        const t=e.touches[0]; panStart={clientX:t.clientX,clientY:t.clientY,x,y};
        viewport.classList.add('is-local-zoom-panning');
      }
    }, {passive:false});

    viewport.addEventListener('touchmove', e => {
      if (e.touches.length === 2 && startDistance && startMid) {
        e.preventDefault(); moved=true;
        const nextMid=mid(e.touches[0],e.touches[1]);
        const nextScale=clamp(startScale*(dist(e.touches[0],e.touches[1])/startDistance),MIN_SCALE,MAX_SCALE);
        const rect=viewport.getBoundingClientRect();
        const localX=startMid.x-rect.left, localY=startMid.y-rect.top;
        const ratio=nextScale/scale;
        x=localX-(localX-x)*ratio+(nextMid.x-startMid.x);
        y=localY-(localY-y)*ratio+(nextMid.y-startMid.y);
        scale=nextScale; startMid=nextMid; apply();
      } else if (e.touches.length === 1 && scale > 1 && panStart) {
        e.preventDefault(); moved=true;
        const t=e.touches[0]; x=panStart.x+t.clientX-panStart.clientX; y=panStart.y+t.clientY-panStart.clientY; apply();
      }
    }, {passive:false});

    viewport.addEventListener('touchend', e => {
      if (e.touches.length < 2) { startDistance=0; startMid=null; }
      if (e.touches.length) return;
      panStart=null; viewport.classList.remove('is-local-zoom-panning');
      if (scale < 1.05) reset();
      const now=Date.now();
      if (!moved && now-lastTap < 340) {
        if (scale > 1) reset();
        else {
          scale=2.25;
          const rect=viewport.getBoundingClientRect();
          const t=e.changedTouches[0];
          x=-(t.clientX-rect.left)*(scale-1);
          y=-(t.clientY-rect.top)*(scale-1);
          apply();
        }
        lastTap=0;
      } else if (!moved) lastTap=now;
    }, {passive:true});

    viewport.addEventListener('dblclick', e => {
      e.preventDefault();
      if (scale > 1) reset();
      else { scale=2.25; const r=viewport.getBoundingClientRect(); x=-(e.clientX-r.left)*(scale-1); y=-(e.clientY-r.top)*(scale-1); apply(); }
    });

    viewport.addEventListener('click', e => {
      if (moved || scale > 1) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    viewport._localZoomReset = reset;
  }

  const init = (scope=document) => {
    if (scope.matches?.(SELECTOR)) initViewport(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initViewport);
  };
  const resetAll = () => document.querySelectorAll('[data-local-zoom-ready="true"]').forEach(n => n._localZoomReset?.());
  const observer = new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if(n.nodeType===1) init(n); })));
  const start = () => { init(); observer.observe(document.documentElement,{childList:true,subtree:true}); };
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('brilinton:gallery-updated', () => requestAnimationFrame(() => init()));
  document.addEventListener('royal-pop:model-change', () => { resetAll(); requestAnimationFrame(() => init()); });
  document.addEventListener('click', e => { if(e.target.closest?.('.slider-button,.thumbnail,[data-royal-pop-model-choice]')) resetAll(); });
  window.addEventListener('pageshow', () => requestAnimationFrame(() => init()));
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
